import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

export default function ChatBubble({ message, from }) {
  const isUser = from === 'user'

  return (
    <div className={`mb-2 ${isUser ? 'text-right' : 'text-left'}`}>
      <div
        className={`
          text-sm 
          inline-block 
          px-2
          rounded-md 
          max-w-[90%] 
          break-words 
          overflow-hidden
          text-left
          ${isUser ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'}
        `}
      >
        {typeof message === 'string' ? (
          <ReactMarkdown
            remarkPlugins={remarkGfm}
            components={{
              a: ({ href, children }) => (
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-blue-600 hover:text-blue-800"
                >
                  {children}
                </a>
              ),
            }}
          >
            {message}
          </ReactMarkdown>
        ) : (
          message
        )}
      </div>
    </div>
  )
}
